export default __webpack_public_path__ + "static/media/Ice_Bucket.6450bb7e.svg";